export default class Filters {
    constructor(element) {
        this.filters = element

        this.filtersMobileButton = this.filters.querySelector('.filters-mobile-button')
        this.filtersCloseButton = this.filters.querySelector('.filters-close')

        this.filtersMobileButton.addEventListener('click', () => this.handleFiltersMobileButtonClick())
        this.filtersCloseButton.addEventListener('click', () => this.handleFiltersCloseButton())
    }

    handleFiltersMobileButtonClick() {
        this.filters.querySelector('.container-lg').classList.add('toggle')
        document.querySelector('body').classList.add('noscroll')
    }

    handleFiltersCloseButton() {
        this.filters.querySelector('.container-lg').classList.remove('toggle')
        document.querySelector('body').classList.remove('noscroll')
    }
}